import { useEffect, useRef } from 'react';
import { echo } from './echo';

export type MessagePayload = {
  message: {
    id: string;
    body: string;
    created_at: string;
    sender_user_name?: string | null;
    sender_farm_id: number;
    recipient_farm_id: number;
    conversation_id?: string | null;
  };
  timestamp: string;
};

export type MessagesReadPayload = {
  message_ids: string[];
  timestamp: string;
};

type Options = {
  farmId: number | string | null | undefined;
  onMessageCreated?: (payload: MessagePayload) => void;
  onMessagesRead?: (messageIds: string[]) => void;
};

export function useRealtimeMessages({
  farmId,
  onMessageCreated,
  onMessagesRead,
}: Options) {
  const onMessageCreatedRef = useRef(onMessageCreated);
  onMessageCreatedRef.current = onMessageCreated;
  const onMessagesReadRef = useRef(onMessagesRead);
  onMessagesReadRef.current = onMessagesRead;

  useEffect(() => {
    if (!farmId) return;

    const chanName = `farms.${farmId}`;
    const channel = (echo as any).private(chanName);

    const handleMessageCreated = (payload: MessagePayload) => {
      onMessageCreatedRef.current?.(payload);
    };

    const handleMessageRead = (payload: MessagesReadPayload) => {
      onMessagesReadRef.current?.(payload?.message_ids ?? []);
    };

    channel.listen('.message.created', handleMessageCreated);
    channel.listen('.message.read', handleMessageRead);

    return () => {
      try {
        channel.stopListening('.message.created', handleMessageCreated);
        channel.stopListening('.message.read', handleMessageRead);
      } catch {}
    };
  }, [farmId]);
}
